import { useEffect, useState } from "react";
import { Generico } from "../../components/Generico";
import { ControlResponsable } from "../../models/riesgo/ControlResponsable";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { useForm } from "react-hook-form";
import { InputComponent } from "../../components/InputComponent";
import { confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { Panel } from "primereact/panel";
import { Dialog } from "primereact/dialog";
import { Criterios } from "./Criterios";

export const Monitoreo = ({ generic, permss, toast, riesgo, id, catalogo, funcionalidades }) => {
    const omodel = new ControlResponsable();
    const matrizSrv = new MonitoreoService();
    const { accionesTbl } = Generico();
    const defaultValues = generic.default(omodel.model);
    const [registros, setRegistros] = useState(null);
    const [item, setItem] = useState(null);
    const [dialogCriterio, setDialogCriterio] = useState(false);
    const [dialogRevision, setDialogRevision] = useState(false);
    const [tipo, setTipo] = useState(null);
    const [lista, setLista] = useState(null);
    const [titulo, setTitulo] = useState(null);
    const [load, setLoad] = useState(false);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const { table, setLoading, setTotalRecords, lazyParams, inDrop } =
        InputComponent({ registers: registros, omodel, generic, errors, control, permss, id: getValues('id') });

    useEffect(() => {
        setLista(catalogo);
        loadLazyData();
    }, [lazyParams]);

    const loadLazyData = () => {
        setLoading(true);
        const _lazyParams = lazyParams;
        _lazyParams.idp = id;
        matrizSrv.listado('matriz-riesgo-monitoreo/lista', { lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setRegistros(res.data.registros);
            setLoading(false);
        });
    }

    const openNew = () => {
        reset(defaultValues);
        setDialogRevision(true);
    }

    const onSubmit = (data) => {
        data.idp = id;
        setLoad(true);
        if (getValues('id') == null) {
            matrizSrv.nuevo(data, 'matriz-riesgo-monitoreo/nuevo').then(res => {
                generic.funcSuccess(res, toast);
                setDialogRevision(false);
                loadLazyData();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            }).finally(() => {
                setLoad(false);
            });
        }
        else {
            matrizSrv.editar(data, 'matriz-riesgo-monitoreo/editar').then(res => {
                generic.funcSuccess(res, toast);
                setDialogRevision(false);
                loadLazyData();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            }).finally(() => {
                setLoad(false);
            });
        }
    }

    const editar = () => {
        matrizSrv.consultar(`${item?.id}/${id}`, 'matriz-riesgo-monitoreo/consulta').then(res => {
            const _riesgo = res.data;
            reset(generic.renewValues(_riesgo, omodel.model));
            setDialogRevision(true);
        });
    }

    const confirmDelete = () => {
        confirmDialog({
            group: 'eliminar-riesgo',
            message: '¿Está seguro de eliminar la información?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => eliminar()
        });
    }

    const eliminar = () => {
        matrizSrv.eliminar(`${item?.id}/${id}`, 'matriz-riesgo-monitoreo/eliminar').then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const customDialogHeader = () => {
        return (
            <div>
                <i className="pi pi-user-edit icon-header" />
                <span className="title-header">
                    {getValues('id') == null ? " Nuevo " : " Editar "}
                </span>
            </div>
        );
    }

    const headerTemplate = (options) => {
        return (
            <div className={options.className}>
                <div className="flex align-items-center gap-2">
                    {permss?.crear && siOpcion('MATRIZ-RIESGOS-CRUD-MONITOREO-REVISION') && <Button icon="pi pi-plus" className="p-button-rounded p-button-success mr-2" type="button" onClick={openNew} />}
                    <span className="font-bold">CONTROLES Y RESPONSABLES PARA EL MONITOREO Y REVISIÓN DEL RIESGO</span>
                </div>
            </div>
        );
    }

    const seleccion = (info, listado) => {
        const _lista = lista;
        _lista[tipo] = listado;
        setLista(_lista);
    }

    const siOpcion = (strOpcion) => {
        return permss?.actualizar && (funcionalidades.includes('PRELAFIT') || funcionalidades.includes(strOpcion));
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar && siOpcion('MATRIZ-RIESGOS-CRUD-MONITOREO-REVISION'))
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editar() } });
        if (permss?.eliminar && siOpcion('MATRIZ-RIESGOS-CRUD-MONITOREO-REVISION'))
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmDelete() } });

        return [{ label: 'Opciones', items: items }];
    }

    const criterios = (opc, ccampo) => {
        setTitulo(omodel?.model[ccampo]?.header);
        setTipo(opc);
        setDialogCriterio(true);
    }

    return (
        <>
            <Panel headerTemplate={headerTemplate}>
                <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                    {table({ action01: accionesTbl, reg: setItem, items: itemsMenu() })}
                </div>
            </Panel>

            <Dialog visible={dialogRevision} header={customDialogHeader} modal className="p-fluid dialog-personalizado" onHide={() => {
                setDialogRevision(false);
            }}
                style={{ width: '400px' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid">
                        {inDrop('revision', lista?.MTR_RIESGO_MONITOREO_REVISION, { lab: 'nombre' }, 11)}
                        <div className="field col-1" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                            <Button icon="pi pi-search-plus" rounded severity="info" type="button" tooltip="Añadir"
                                onClick={() => criterios('MTR_RIESGO_MONITOREO_REVISION', 'revision')} />
                        </div>

                        {inDrop('responsable', lista?.MTR_RIESGO_ACTOR_INTERNO, { lab: 'nombre' }, 11)}
                        <div className="field col-1" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                            <Button icon="pi pi-search-plus" rounded severity="info" type="button" tooltip="Añadir actores internos"
                                onClick={() => criterios('MTR_RIESGO_ACTOR_INTERNO', 'responsable')} />
                        </div>
                    </div>
                    {generic.buttonsForms(setDialogRevision, load)}
                </form>
            </Dialog>

            <Dialog visible={dialogCriterio} header={titulo} modal className="p-fluid dialog-personalizado" onHide={() => {
                setDialogCriterio(false);
                setTipo(null);
            }}
                style={{ maxWidth: '500px' }}>
                {tipo && <Criterios toast={toast} permss={permss} generic={generic} riesgo={riesgo} tipo={tipo} seleccion={seleccion} seleccionar={false} listar="solo" funcionalidades={funcionalidades} />}
            </Dialog>
        </>
    )
}
